(function () {
	'use strict';
  
	const LOTTIE_SPEED = 1.0;
	// Minimum time Lottie stays on screen before the real navigation starts.
	const MIN_ANIMATION_MS = 600;
	// Safety cap in case the prefetch hangs.
	const MAX_WAIT_MS = 2500;
  
	let overlay = null;
	let animContainer = null;
	let lottieAnim = null;
	let navigating = false;
	/** @type {string[]} */
	const sources = [];
  
	function init() {
	  overlay = document.getElementById('slow-loading-overlay');
	  if (!overlay) return;
  
	  animContainer = overlay.querySelector('.slow-loading-animation');
	  if (animContainer) {
		const src1 = animContainer.getAttribute('data-lottie-src');
		const src2 = animContainer.getAttribute('data-lottie-src-2');
		if (src1) sources.push(src1);
		if (src2) sources.push(src2);
	  }
  
	  // Bubble phase so theme scripts (menu, drawer, ...) can call preventDefault first.
	  window.addEventListener('click', onClick, false);
  
	  // Safari restores this page from bfcache when the user hits Back. Without
	  // this, the overlay stays visible and `navigating` stays true, blocking
	  // all further link clicks until a hard refresh.
	  window.addEventListener('pageshow', hideOverlay);
	}
  
	function hideOverlay() {
	  navigating = false;
	  if (!overlay) return;
	  overlay.classList.remove('is-visible');
	  overlay.setAttribute('aria-hidden', 'true');
	  if (lottieAnim) {
		try { lottieAnim.destroy(); } catch { /* ignore */ }
		lottieAnim = null;
	  }
	}
  
	function isNavigableLink(link) {
	  if (link.target && link.target !== '' && link.target !== '_self') return false;
	  if (link.hasAttribute('download')) return false;
  
	  const href = link.getAttribute('href');
	  if (!href || href.startsWith('#')) return false;
	  if (/^(mailto:|tel:|javascript:)/i.test(href)) return false;
  
	  let url;
	  try {
		url = new URL(link.href, location.href);
	  } catch {
		return false;
	  }
  
	  if (url.origin !== location.origin) return false;
	  if (url.pathname === location.pathname && url.search === location.search && url.hash) {
		return false;
	  }
  
	  // Cart: opens the drawer via theme JS, no navigation.
	  if (/^\/cart(\/|$)/.test(url.pathname)) return false;
	  if (link.closest('.menu-tools__link--cart, form[action*="/cart"]')) return false;
	  // Header tool icons: no overlay for search/account/wishlist.
	  if (link.closest('.menu-tools__link--search, .menu-tools__link--account, .menu-tools__link--wishlist')) return false;
  
	  return url;
	}
  
	function onClick(e) {
	  // Another script already handled the click (e.g. search drawer open).
	  if (e.defaultPrevented) return;
	  if (e.button !== undefined && e.button !== 0) return;
	  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  
	  const link = e.target?.closest?.('a[href]');
	  if (!link) return;
  
	  const url = isNavigableLink(link);
	  if (!url) return;
  
	  if (navigating) {
		e.preventDefault();
		return;
	  }
  
	  e.preventDefault();
	  navigating = true;
	  showOverlay();
	  prefetchThenNavigate(url.href);
	}
  
	// Warm up the target page via fetch while Lottie keeps playing in the still-alive
	// current page. Trigger the real navigation only after the prefetch resolves
	// (or a timeout) AND Lottie was on screen long enough. Same code path on all
	// browsers so behaviour is consistent between desktop and mobile.
	function prefetchThenNavigate(href) {
	  const started = Date.now();
	  let done = false;
  
	  const go = () => {
		if (done) return;
		done = true;
		const elapsed = Date.now() - started;
		const wait = Math.max(0, MIN_ANIMATION_MS - elapsed);
		setTimeout(() => { window.location.href = href; }, wait);
	  };
  
	  fetch(href, { credentials: 'same-origin', mode: 'same-origin' })
		.then(() => go())
		.catch(() => go());
  
	  setTimeout(go, MAX_WAIT_MS);
	}
  
	function showOverlay() {
	  if (!overlay) return;
	  playRandomAnimation();
	  overlay.classList.add('is-visible');
	  overlay.setAttribute('aria-hidden', 'false');
	}
  
	function playRandomAnimation() {
	  if (lottieAnim || !animContainer || !sources.length) return;
	  if (!window.lottie?.loadAnimation) return;
  
	  const src = sources[Math.floor(Math.random() * sources.length)];
	  try {
		lottieAnim = window.lottie.loadAnimation({
		  container: animContainer,
		  renderer: 'svg',
		  loop: true,
		  autoplay: true,
		  path: src,
		});
		lottieAnim.setSpeed?.(LOTTIE_SPEED);
	  } catch { /* overlay stays visible until navigation kicks in */ }
	}
  
	init();
  })();
  